import React from 'react';
import styled from 'styled-components';
import { COLORS, device } from '../../constants';

interface ProgressBarProps {
  data: any[];
  visibleIndex: number;
  barElementClick: (index: number) => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  data,
  visibleIndex,
  barElementClick,
}) => {
  return (
    <ProgressContainer>
      {data.map((_, index) => (
        <ProgressSquareContainer
          key={index}
          $active={index === visibleIndex}
          onClick={() => barElementClick(index)}
        >
          <ProgressSquare $active={index === visibleIndex} />
        </ProgressSquareContainer>
      ))}
    </ProgressContainer>
  );
};

const ProgressContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-self: center;
  flex: 1;
  justify-content: center;
`;

const ProgressSquare = styled.div<{ $active: boolean }>`
  width: 20px;
  height: 4px;
  background-color: ${props =>
    props.$active ? COLORS.STEP_RED_BORDER : COLORS.BG_CIRCLE};
  transform: ${props => (props.$active ? 'scaleX(2)' : 'scaleX(1)')};
  @media screen and ${device.md} {
    height: ${props => (props.$active ? '40px' : '20px')};
    width: 4px;
    transform: none;
  }
`;

const ProgressSquareContainer = styled.div<{ $active: boolean }>`
  padding: ${props => (props.$active ? '10px 14px' : '10px 4px')};
  @media screen and ${device.md} {
    padding: ${props => (props.$active ? '14px 10px' : '4px 10px')};
  }
  @media screen and ${device.sm} {
    padding: ${props => (props.$active ? '5px 2px' : '5px 4px')};
  }
`;

export { ProgressBar };
